// third party
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { SnackbarProvider } from 'notistack';

// material-ui
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

// routing
import Routes from '../routes';

// defaultTheme
import themes from '../themes';

// project imports
import './App.css';
import NavigationScroll from 'layout/NavigationScroll';
import { AuthProvider } from 'context/auth-context';
import { MenuProvider } from 'context/menu-context';
import { queryClient } from 'lib/react-query';
import config from '../config';

// vesion
import packageJson from '../../package.json';

function App() {
	console.log('version', packageJson.version);
	return (
		<div className="App">
			<BrowserRouter basename={config.basename}>
				<QueryClientProvider client={queryClient}>
					<AuthProvider>
						<MenuProvider>
							<SnackbarProvider autoHideDuration={1000} maxSnack={3}>
								<StyledEngineProvider injectFirst>
									<ThemeProvider theme={themes()}>
										<CssBaseline />
										<NavigationScroll>
											<Routes />
										</NavigationScroll>
									</ThemeProvider>
								</StyledEngineProvider>
							</SnackbarProvider>
						</MenuProvider>
					</AuthProvider>
					{process.env.NODE_ENV === 'development' && <ReactQueryDevtools position="bottom-right" />}
				</QueryClientProvider>
			</BrowserRouter>
		</div>
	);
}

export default App;
